import { render, staticRenderFns } from "./TargetItem.vue?vue&type=template&id=4709720f&scoped=true&"
import script from "./TargetItem.vue?vue&type=script&lang=js&"
export * from "./TargetItem.vue?vue&type=script&lang=js&"
import style0 from "./TargetItem.vue?vue&type=style&index=0&id=4709720f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709720f",
  null
  
)

export default component.exports